import React from 'react';
import PropTypes from 'prop-types';
import ProfessionalGuardianLookupSection from '../../../../../features/bonds/shared/components/sections/ProfessionalGuardianLookupSection';
import { normalizeRetrievalPgConfig } from '../../../../../features/bonds/shared/components/sections/pgSectionConfig';

export default function RetrievalPgSection({
  retrievalCfg,
  isDisabled = false,
  ...rest
}) {
  return (
    <ProfessionalGuardianLookupSection
      {...rest}
      config={normalizeRetrievalPgConfig(retrievalCfg)}
      isDisabled={isDisabled}
    />
  );
}

RetrievalPgSection.propTypes = {
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  retrievalCfg: PropTypes.object.isRequired,
  professionalGuardians: PropTypes.array.isRequired,
  loadingGuardians: PropTypes.bool,
  isDisabled: PropTypes.bool,
  updateGuardianAt: PropTypes.func.isRequired,
  fetchProfessionalGuardianDetails: PropTypes.func.isRequired,
};

RetrievalPgSection.defaultProps = {
  loadingGuardians: false,
  isDisabled: false,
};
